export default {
  parameters: {
    landing_id: "TrScCode",
  },
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    title: '<div><b>5 soruyu yanıtlayın ve çocuğunuz için ÜCRETSİZ ders alın</div></b>',
    image: {
      url:  "/welcome/softtech_coding_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    button: {
      text: "   Ücretsiz alin 🚀  ",
      style: {
        background: "#5988FF",
        color: "#FFFFFF",
        "font-weight": "bold",
      },
    },
    imageMobile: {
      url: "/welcome/softtech_coding_mob.png",
      style: {
        width: "100%",
      },
    },
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title:
      "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz genellikle boş zamanlarını nasıl geçirir?",
      answers: [
        "🎮 Cep telefonu ve bilgisayarda oyun oynar",
        "🎨 Sanatsal faaliyetlerde bulunur: çizim, müzik, oyunculuk",
        "⚽️ Spor yapar",
        "🏕️ Ailesiyle vakit geçirir",
        "👀 Çizgi film izler",
        "🤝 Arkadaşlarıyla sosyalleşir",
      ],
    },
    2: {
      question: "Çocuğunuzun okulda en sevdiği ders hangisidir?",
      answers: [
        "🔬 Fen bilimleri",
        "🎨 Sanat ve tasarım",
        "💻 Bilgisayar bilimi",
        "📙 Tarih, Edebiyat",
        "📐 Matematik",
        "💬 Yabancı diller",
        "🤩 Tüm dersler",
        "🤔 Emin değilim",
      ],
    },
    3: {
      question: "Çocuğunuzun herhangi bir bilgisayar becerisi var mı?",
      answers: [
        "😌 Evet, Microsoft Word/PowerPoint",
        "🖥 Evet, temel kodlama",
        "👍 Evet, oyun oynamayı sever (Roblox, Minecraft)",
        "🤔 Hayır",
      ],
    },
    4: {
      question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
      answers: [
        {
          answer: "💻 Evet",
          distribution_tag_question: [18],
        },
        {
          answer: "😐 Hayır",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "Deneme dersi için hangi saatte uygunsunuz?",
      type: "timeslot",
      subtitle:
        "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
      button: "Rezervasyon için tıklayın 🎁",
    },
    6: {
      title: "Çocuğunuz kaç yaşında?",
      type: "age",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
      button: "İleri 🚀",
    },
    7: {
      title: "Çocuğunuzun adı nedir?",
      type: "child_name",
      subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
      button: "İleri 🚀",
    },
    8: {
      title: "E-postanızı girin",
      type: "mail",
      subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
      button: "İleri 🚀",
    },
    9: {
      title: "Telefon numaranızı girin",
      type: "phone",
      subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
      button: "Neredeyse bitti 🔥",
    },
    10: {
      title: "İsminizi girin",
      type: "parent_name",
      subtitle: "Bizim adımız Kodland, sizinki ne?👋",
      button: "Son adım! 🎉",
    },
  },
};
